module.exports = __webpack_public_path__ + "static/rage-clicks-47660a587be4cd5e670005df69b86db1.png";